module.exports = __webpack_public_path__ + "img/what-we-value.dc071b4e.png";